import React from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '../../../../lib/utils';
import { extraSmallTextSize, mediumText, roundedLG } from '../../../../styling/stylingHelper';
import { AccessType } from '../staffAccessUtils';

interface StaffAccessBadgesProps {
  accessType: AccessType | null;
  className?: string;
}

const badgeBase = cn(extraSmallTextSize, mediumText, roundedLG, 'px-2 py-0.5 leading-5 shrink-0');
const foodBadge = 'bg-orange-100 dark:bg-orange-900/30 text-orange-700 dark:text-orange-300';
const drinksBadge = 'bg-purple-100 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300';

/**
 * Food / Drinks pills for a restricted access type. Renders nothing for 'all' or
 * null so callers can drop it in unconditionally; 'mixed' shows both pills.
 */
const StaffAccessBadges: React.FC<StaffAccessBadgesProps> = ({ accessType, className }) => {
  const { t } = useTranslation();

  if (!accessType || accessType === 'all') return null;

  const showFood = accessType === 'food' || accessType === 'mixed';
  const showDrinks = accessType === 'drinks' || accessType === 'mixed';

  return (
    <span className={cn('flex items-center gap-1.5', className)}>
      {showFood && <span className={cn(badgeBase, foodBadge)}>{t('staff.food')}</span>}
      {showDrinks && <span className={cn(badgeBase, drinksBadge)}>{t('staff.drinks')}</span>}
    </span>
  );
};

export default StaffAccessBadges;
